import React, { useEffect, useState } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import SiteAuditTable from "./SiteAuditTable";
import { fetchWithToken } from "../../../../apiUtils";

const useStyles = makeStyles({
  table: {
    marginTop: 45,
  },
  loading: {
    marginTop: "25%",
    marginLeft: "50%",
  },
});

const SiteAudit = () => {
  const classes = useStyles();

  const [dataObj, setDataObj] = useState({
    siteAudits: [],
    loading: true,
  });

  useEffect(() => {
    fetchWithToken("api/SiteAudit/")
      .then((response) => response.json())
      .then((data) =>
        setDataObj({
          siteAudits: data,
          loading: false,
        })
      );
  }, []);

  return (
    <>
      {dataObj.loading ? (
        <CircularProgress className={classes.loading} />
      ) : (
        <div className={classes.table}>
          <SiteAuditTable data={dataObj.siteAudits} />
        </div>
      )}
    </>
  );
};

export default SiteAudit;
